import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdvantagesPage} from 'src/app/ui/webapp/page/unit-linked/insurance/advantages/advantages.page';
import {InsurancePage} from 'src/app/ui/webapp/page/unit-linked/insurance/insurance.page';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: InsurancePage
      },
      {
        path: 'advantages',
        component: AdvantagesPage
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class InsuranceRoutingModule {}
